













import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class Tip extends Vue {
  @Prop({
    default: null
  })
  closable: any

  @Prop()
  id: string

  @Prop({
    default: 'Tip!'
  })
  tip: string

  @Prop({
    default: 'accent'
  })
  type: string

  hidden: boolean = false

  close() {
    this.hidden = true

    if (this.id) {
      localStorage.setItem('tip_' + this.id, '1')
    }
  }

  created() {
    if (this.id) {
      const isHidden: any = localStorage.getItem('tip_' + this.id)

      if (isHidden) {
        this.hidden = true
      }
    }
  }
}
